export default "__VITE_ASSET__CDyVLlfU__"